/* Climate Flow motion: scroll reveal, count-up stats, hero video guard. Respects reduced motion and the theme editor. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && window.Shopify.designMode;
  const saveData = navigator.connection && navigator.connection.saveData;

  /* Hero video: pause (poster only) for reduced motion or data saver. */
  document.querySelectorAll('[data-cf-video] video').forEach((video) => {
    if (reduce || saveData) {
      video.removeAttribute('autoplay');
      video.pause();
      video.closest('[data-cf-video]').classList.add('is-static');
    } else {
      video.muted = true;      
      video.closest('[data-cf-video]').classList.add('cf-fade');
      if (!video.paused && video.readyState > 2) video.classList.add('is-playing');
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      const play = video.play();
      if (play && play.catch) play.catch(() => video.closest('[data-cf-video]').classList.add('is-static'));
    }
  });

  if (reduce || designMode || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-cf-count]').forEach((el) => (el.textContent = el.dataset.cfCount));
    return;
  }

  /* Scroll reveal: headings, cards and tiles rise in; siblings stagger. */
  const selectors = [
    '.cf-section .cf-h2', '.cf-intro', '.cf-card', '.cf-step', '.cf-intent__tile', '.cf-linkcard',
    '.cf-guide', '.cf-badge', '.cf-stat', '.cf-ff__grid', '.cf-formcard', '.cf-faq__item',
    '.cf-jobsheet__panel', '.cf-areas__list li', '.cf-band__inner', '.cf-reviews__summary', '.cf-marquee'
  ].join(',');
  const items = [...document.querySelectorAll(selectors)].filter((el) => !el.closest('.cf-hero'));
  items.forEach((el) => {
    const siblings = el.parentElement ? [...el.parentElement.children].filter((c) => c.matches(selectors)) : [el];
    const index = Math.max(0, siblings.indexOf(el));
    el.style.setProperty('--cf-delay', `${Math.min(index, 8) * 70}ms`);
    el.classList.add('cf-reveal');
  });

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      revealObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  items.forEach((el) => revealObserver.observe(el));

  /* Count-up numbers. */
  const countObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      countObserver.unobserve(el);
      const target = parseFloat(el.dataset.cfCount);
      const start = parseFloat(el.dataset.cfFrom || '0');
      const duration = 1400;
      const t0 = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - t0) / duration);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(start + (target - start) * eased).toLocaleString('en-GB');
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('[data-cf-count]').forEach((el) => {
    el.textContent = el.dataset.cfFrom || '0';
    countObserver.observe(el);
  });

  document.documentElement.classList.add('cf-motion');
})();
